import Locale from '@/helper/locale/Locale.js';
import Util from '@/helper/Utility.js';

/**
 * @export CampaignConfigModel
 * @export CampaignConfigBuilder
 * @export CampaignListConfigModel
 * @export CampaignListConfigBuilder
 * @export CampaignListFilterConfigModel
 * @export CampaignListFilterConfigBuilder
 */

//#region Campaign
export function CampaignConfigModel(strId, strType, isWithRelate, strRelateConfig, numRelateTop, strSponsorId, strRedeemMedia, strWalletCard) {
    this.strId = strId || null;
    this.strLocale = Locale.getLocaleCode();
    this.strType = strType || null;
    this.isWithRelate = isWithRelate || false;
    this.strRelateConfig = strRelateConfig || null;
    this.numRelateTop = numRelateTop || 0;
    this.strSponsorId = strSponsorId || null;
    this.strRedeemMedia = strRedeemMedia || null;
    this.strWalletCard = strWalletCard || null;

    this.updateListConfig = function (objCampaignConfig) {
        this.strId = objCampaignConfig.strId;
        this.strLocale = objCampaignConfig.strLocale;
        this.strType = objCampaignConfig.strType;
        this.isWithRelate = objCampaignConfig.isWithRelate;
        this.strRelateConfig = objCampaignConfig.strRelateConfig;
        this.numRelateTop = objCampaignConfig.numRelateTop;
        this.strSponsorId = objCampaignConfig.strSponsorId;
        this.strRedeemMedia = objCampaignConfig.strRedeemMedia;
        this.strWalletCard = objCampaignConfig.strWalletCard;
    };

    this.getParams = function() {
        var params = {
            type: this.strType,
            device_locale: this.strLocale ,
            with_relate: this.isWithRelate,
            relate_config: this.strRelateConfig,
            relate_top: this.numRelateTop,
            sponsorId: this.strSponsorId,
            redeem_media: this.strRedeemMedia,
            // walletcard: this.strWalletCard,
        };
        params = Util.cleanObjectEmptyStr(params);
        return params
    };
}
export function CampaignConfigBuilder() {
    this.campaignConfig = new CampaignConfigModel();

    this.create = () => {
        return this.campaignConfig;
    };

    this.setCampaignId = (strId) => {
        this.campaignConfig.strId = strId;
        return this;
    };

    this.setLocale = () => {
        this.campaignConfig.strLocale = Locale.getLocaleCode();
        return this;
    };

    this.setType = (strType) => {
        this.campaignConfig.strType = strType;
        return this;
    };

    this.setWithRelate = (isWithRelate) => {
        this.campaignConfig.isWithRelate = isWithRelate;
        return this;
    };

    this.setRelateConfig = (strRelateConfig) => {
        this.campaignConfig.strRelateConfig = strRelateConfig;
        return this;
    };

    this.setRelateTop = (numRelateTop) => {
        this.campaignConfig.numRelateTop = numRelateTop;
        return this;
    };

    this.setSponsorId = (strSponsorId) => {
        this.campaignConfig.strSponsorId = strSponsorId;
        return this;
    };

    this.setRedeemMedia = (strRedeemMedia) => {
        this.campaignConfig.strRedeemMedia = strRedeemMedia;
        return this;
    };

    this.setWalletCard = (strWalletCard) => {
        this.campaignConfig.strWalletCard = strWalletCard;
        return this;
    };
}
//#endregion Campaign
//#region List
export function CampaignListConfigModel(strConfigList, intTop, strCatId, intSkip, strTags, strType, strMode, strCampaignImageSize) {
    this.isSeeMoreEnable = true;
    this.strConfigList = strConfigList || '';
    this.intSkip = intSkip || 0;
    this.defaultTopAmount = intTop || 25;
    this.strCatId = strCatId || '';
    this.strTags = strTags || '';
    this.strLocale = Locale.getLocaleCode();
    this.strType = strType || '';
    this.strMode = strMode || '';
    this.strCampaignImageSize = strCampaignImageSize || 'large';

    this.updateListConfig = function (campaignListConfig) {
        this.isSeeMoreEnable = campaignListConfig.isSeeMoreEnable;
        this.strConfigList = campaignListConfig.strConfigList;
        this.intSkip = campaignListConfig.intSkip;
        this.defaultTopAmount = campaignListConfig.defaultTopAmount;
        this.strCatId = campaignListConfig.strCatId;
        this.strTags = campaignListConfig.strTags;
        this.strLocale = Locale.getLocaleCode();
        this.strType = campaignListConfig.strType;
        this.strMode = campaignListConfig.strMode;
        this.strCampaignImageSize = campaignListConfig.strCampaignImageSize;
    };

    this.resetListConfig = function () {
        this.isSeeMoreEnable = true;
        this.intSkip = 0;
        this.strLocale = Locale.getLocaleCode();
    };

    this.getParams = function() {
        var params = {
            byConfig: "true",
            config: this.strConfigList,
            $top: this.defaultTopAmount,
            $skip: this.intSkip,
            tags: this.strTags,
            cat: this.strCatId,
            device_locale: this.strLocale,
            type: this.strType,
            mode: this.strMode,
        };
        params = Util.cleanObjectEmptyStr(params);
        return params;
    };
}

export function CampaignListConfigBuilder() {
    this.campaignListConfig = new CampaignListConfigModel();

    this.create = () => {
        return this.campaignListConfig;
    };

    this.setSeeMore = (isSeeMoreEnable) => {
        this.campaignListConfig.isSeeMoreEnable = isSeeMoreEnable;
        return this;
    };

    this.setCampaignImageSize = (strImageSize) => {
        this.campaignListConfig.strCampaignImageSize = strImageSize;
        return this;
    };

    this.setCatId = (strCatId) => {
        this.campaignListConfig.strCatId = strCatId;
        return this;
    };

    this.setConfigList = (strConfig) => {
        this.campaignListConfig.strConfigList = strConfig;
        return this;
    };

    this.setLocale = () => {
        this.campaignListConfig.strLocale = Locale.getLocaleCode();
        return this;
    };

    this.setMode = (strMode) => {
        this.campaignListConfig.strMode = strMode;
        return this;
    };

    this.setSkip = (intSkip) => {
        this.campaignListConfig.intSkip = intSkip;
        return this;
    };

    this.setTags = (strTags) => {
        this.campaignListConfig.strTags = strTags;
        return this;
    };

    this.setType = (strType) => {
        this.campaignListConfig.strType = strType;
        return this;
    };

    this.setTop = (intTop) => {
        this.campaignListConfig.defaultTopAmount = intTop;
        return this;
    };
}

export function CampaignListFilterConfigModel(strSearch, strStartDate, strNearby, strLocation, strLocationAgencyId, intMinPoint, intMaxPoint, intMinPrice, intMaxPrice, intMinRating, intMaxRating) {
    this.strSearch = strSearch || '';
    this.strNearby = strNearby || '';
    this.strStartDate = strStartDate || '';
    this.intMinPoint = intMinPoint || '';
    this.intMaxPoint = intMaxPoint || '';
    this.intMinPrice = intMinPrice || '';
    this.intMaxPrice = intMaxPrice || '';
    this.intMinRating = intMinRating || '';
    this.intMaxRating = intMaxRating || '';
    this.strLocation = strLocation || '';
    this.strLocationAgencyId = strLocationAgencyId || '';

    this.updateFilterListConfig = function (objCampaignListFilterConfig) {
        this.strSearch = objCampaignListFilterConfig.strSearch;
        this.strNearby = objCampaignListFilterConfig.strNearby;
        this.strStartDate = objCampaignListFilterConfig.strStartDate;
        this.intMinPoint = objCampaignListFilterConfig.intMinPoint;
        this.intMaxPoint = objCampaignListFilterConfig.intMaxPoint;
        this.intMinPrice = objCampaignListFilterConfig.intMinPrice;
        this.intMaxPrice = objCampaignListFilterConfig.intMaxPrice;
        this.intMinRating = objCampaignListFilterConfig.intMinRating;
        this.intMaxRating = objCampaignListFilterConfig.intMaxRating;
        this.strLocation = objCampaignListFilterConfig.strLocation;
        this.strLocationAgencyId = objCampaignListFilterConfig.strLocationAgencyId;
    };

    this.getParams = function() {
        var params = {
            q: this.strSearch,
            startdate: this.strStartDate,
            center: this.strNearby,
            location: this.strLocation,
            locationAgencyId: this.strLocationAgencyId,
            minpoints: this.intMinPoint,
            maxpoints: this.intMaxPoint,
            minprice: this.intMinPrice,
            maxprice: this.intMaxPrice,
            minrating: this.intMinRating,
            maxrating: this.intMaxRating,
        };
        params = Util.cleanObjectEmptyStr(params);
        return params;
    };
}

export function CampaignListFilterConfigBuilder() {
    this.campaignListFilterConfig = new CampaignListFilterConfigModel();

    this.create = () => {
        return this.campaignListFilterConfig;
    };

    this.setLocation = (strLocation) => {
        this.campaignListFilterConfig.strLocation = strLocation;
        return this;
    };

    this.setLocationAgency = (strLocationAgencyId) => {
        this.campaignListFilterConfig.strLocationAgencyId = strLocationAgencyId;
        return this;
    };

    this.setMinPoint = (intMinPoint) => {
        this.campaignListFilterConfig.intMinPoint = intMinPoint;
        return this;
    };

    this.setMaxPoint = (intMaxPoint) => {
        this.campaignListFilterConfig.intMaxPoint = intMaxPoint;
        return this;
    };

    this.setMinPrice = (intMinPrice) => {
        this.campaignListFilterConfig.intMinPrice = intMinPrice;
        return this;
    };

    this.setMaxPrice = (intMaxPrice) => {
        this.campaignListFilterConfig.intMaxPrice = intMaxPrice;
        return this;
    };

    this.setMinRating = (intMinRating) => {
        this.campaignListFilterConfig.intMinRating = intMinRating;
        return this;
    };

    this.setMaxRating = (intMaxRating) => {
        this.campaignListFilterConfig.intMaxRating = intMaxRating;
        return this;
    };

    this.strNearby = (strNearby) => {
        this.campaignListFilterConfig.strNearby = strNearby;
        return this;
    };

    this.setSearch = (strSearch) => {
        this.campaignListFilterConfig.strSearch = strSearch;
        return this;
    };

    this.setStartDate = (strStartDate) => {
        this.campaignListFilterConfig.strStartDate = strStartDate;
        return this;
    }
}
//#endregion List
